import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import React, {useState} from 'react'
import {useNiftyFiftyTemplate} from 'Event/template/NiftyFifty'
import MainNavButtonConfig from 'Event/template/NiftyFifty/Dashboard/MainNav/MainNavButton/MainNavButtonConfig'

export default function NewMainNavButton(props: {className?: string}) {
  const template = useNiftyFiftyTemplate()
  const {
    mainNav: {buttons},
  } = template
  const [button, setButton] = useState<NavButtonWithSize | null>(null)

  if (!buttons) {
    return null
  }

  const addButton = () => {
    const button: NavButtonWithSize = {
      text: 'Button',
      link: '',
      rules: [],
      isAreaButton: false,
      isFormButton: false,
      isImageUpload: false,
      isCertificateButton: false,
      areaId: null,
      formId: null,
      certificateId: null,
      size: 12,
      actionId: null,
      isVisible: true,
      infusionsoftTag: null,
      mailchimpTag: null,
      zapierTag: null,
      highLevelTag: null,
      webhook: null,
      image: '',
      backgroundColor: '#000000',
      textColor: '#FFFFFF',
      hoverBackgroundColor: '#000000',
      disableHover: true,
      hubspotTag: null,
      hubspotV2Tag: null,
      activeCampaignTag: null,
      convertKitTag: null,
      ontraportTag: null,
      clickFunnelsTag: null,
    }

    setButton(button)
  }
  return (
    <>
      <NewButtonConfig button={button} onClose={() => setButton(null)} />
      <StyledButton
        fullWidth
        size="large"
        variant="outlined"
        color="primary"
        aria-label="add main nav button"
        onClick={addButton}
        className={props.className}
      >
        New Button
      </StyledButton>
    </>
  )
}

function NewButtonConfig(props: {
  button: NavButtonWithSize | null
  onClose: () => void
}) {
  if (!props.button) {
    return null
  }

  return (
    <MainNavButtonConfig
      button={props.button}
      showing
      onClose={props.onClose}
    />
  )
}

const StyledButton = styled(Button)`
  margin-top: ${(props) => props.theme.spacing[2]}!important;
`
